// Supervisor (مشرف) permissions: one catalog for the supervisors page (views/admins/index.vue).
// A supervisor's `pers` is a plain array of codes, read by checkPer() in the dashboard, by the
// school app and by the server:
//   '*'                      everything, including managing supervisors (there is no separate
//                            'admins' code: the server lets only the school and '*' into that page)
//   'students', 'teachers'…  «تفعيل خدمة» for that service (the service's pages and menu)
//   'students|scan|manual'…  one page or action inside a service, or a general page ('settings')
//   'الأول المتوسط'…         an allowed class (classname): the students list and class pickers show
//                            only these classes to the supervisor; no class = no students there.
//
// To add a permission: add one line { key, title, hint } to its area below. Optional fields:
//   requires: [keys]   switched on together with it (and it goes off when one of them goes off)
//   needsOne: [keys]   needs at least one of these; the first is switched on if none is
//   also:     [keys]   extra codes written with it (menu entries that use another code)
//   basic: true        on by default when the service is switched on
//   write: true        changes data (an item without it only shows things)

var CATALOG = [
    {
        service: '',
        title: 'صلاحيات عامة',
        icon: 'fa-sliders',
        areas: [
            { id: 'account', title: 'الحساب', items: [
                { key: 'settings', title: 'اعدادات الحساب', hint: 'بيانات المدرسة والشعار والمراحل', write: true },
                { key: 'subscribe', title: 'الفواتير والاشتراكات', hint: 'عرض الاشتراكات وتجديدها ودفع الفواتير', write: true },
                { key: 'app-settings', title: 'اعدادات تطبيق ولي الأمر', hint: 'الأخبار وموعد الخروج وما يظهر لأولياء الأمور', write: true },
                { key: 'devices', title: 'اجهزة البصمة', hint: 'إضافة أجهزة البصمة وربطها', write: true },
            ] },
            { id: 'messages', title: 'الرسائل', items: [
                { key: 'archive', title: 'ارشيف الرسائل والإشعارات', hint: 'سجل الرسائل وإشعارات التطبيق وقوالب الرسائل' },
                { key: 'alsl', title: 'اعدادات الـSMS', hint: 'بوابة الرسائل النصية واسم المرسل', write: true },
                { key: 'xwa', title: 'اداة الواتس المباشر', hint: 'الإرسال من رقم واتساب المدرسة', write: true },
            ] },
            { id: 'forwards', title: 'التحويلات', items: [
                { key: 'forwards', title: 'المحول للوكيل', hint: 'الطلاب المحولون من المعلمين للوكيل', write: true },
                { key: 'students|forwards2', title: 'المحول للموجه', hint: 'الطلاب المحولون للموجه الطلابي', write: true },
            ] },
        ],
    },
    {
        service: 'students',
        icon: 'fa-users',
        areas: [
            { id: 'view', title: 'الطلاب', items: [
                { key: 'students|stats', also: ['students|home'], title: 'الصفحة الرئيسية والإحصائيات', hint: 'أرقام الحضور والغياب اليوم', basic: true },
                { key: 'students|students|view', title: 'استعراض الطلاب', hint: 'قائمة الطلاب وملف كل طالب', basic: true },
                { key: 'students|students|add', title: 'إضافة واستيراد الطلاب', hint: 'إضافة طالب أو استيراد ملف نور', write: true },
                { key: 'students|students|edit', title: 'تعديل بيانات الطلاب', hint: 'الاسم والجوال والفصل', requires: ['students|students|view'], write: true },
                { key: 'students|students|delete', title: 'حذف الطلاب', hint: 'حذف طالب أو فصل كامل', requires: ['students|students|view'], write: true },
                { key: 'students|students|move', title: 'نقل الطلاب بين الفصول', hint: 'نقل وإعادة تسمية الفصول', write: true },
                { key: 'students|students|send', title: 'ارسال رسائل وإشعارات', hint: 'رسائل لأولياء الأمور وإشعار فوري للتطبيق', write: true },
                { key: 'students|rates', title: 'تقييمات الطلاب', hint: 'إضافة التقييمات وحذفها', write: true },
                { key: 'students|health', title: 'الملاحظات الصحية', hint: 'إضافة وتعديل الحالات الصحية', write: true },
                { key: 'students|weeklyplan', title: 'خطة التعليم الأسبوعي', hint: 'إعداد الخطة الأسبوعية للفصول', write: true },
                { key: 'students|chat', title: 'محادثات أولياء الأمور', hint: 'مراسلة أولياء الأمور من اللوحة والتطبيق', write: true },
                { key: 'students|archive', title: 'ارشيف رسائل الطلاب', hint: 'الرسائل والإشعارات المرسلة لأولياء الأمور' },
            ] },
            { id: 'scan', title: 'التحضير', items: [
                { key: 'students|scan|manual', title: 'تحضير يدوي', hint: 'تسجيل الحضور باختيار الطالب', write: true },
                { key: 'students|scan|barcode', title: 'تحضير بالباركود', hint: 'قارئ الباركود أو كاميرا الجهاز', write: true },
                { key: 'students|scan|bulk', title: 'تحضير جماعي للفصول', hint: 'تحضير فصل كامل مرة واحدة', write: true },
                { key: 'students|scan|endex', title: 'شاشة الاستئذان', hint: 'تسجيل استئذان الطالب من لوحة المدرسة', write: true },
                { key: 'students|scan|end', title: 'الاستئذان من الجوال', hint: 'تسجيل الاستئذان من تطبيق المدرسة', write: true },
                { key: 'students|scan|ends', title: 'شاشة الانصرافات', hint: 'انصراف الطلاب نهاية اليوم', write: true },
                { key: 'students|notes', title: 'ملاحظات الطلاب عند الدخول والاستئذان', hint: 'ملاحظة تظهر عند تحضير الطالب أو استئذانه', write: true },
                { key: 'students|scan|phone', title: 'تحضير من الجوال', hint: 'تحضير الطلاب من تطبيق المدرسة', write: true },
                { key: 'students|reports|attend-before', title: 'تحضير فترة ماضية', hint: 'تسجيل حضور أيام سابقة', write: true },
            ] },
            { id: 'reports', title: 'التقارير', items: [
                { key: 'students|reports|daily', requires: ['students|reports'], title: 'الحضور والغياب اليومي', hint: 'تقرير اليوم لكل الطلاب', basic: true },
                { key: 'students|reports|between', requires: ['students|reports'], title: 'تقارير فترة', hint: 'الحضور والغياب بين تاريخين' },
                { key: 'students|reports|classrooms', requires: ['students|reports'], title: 'احصائيات الفصول', hint: 'نسب الحضور لكل فصل' },
                { key: 'students|reports|edit', needsOne: ['students|reports|daily', 'students|reports|between'], title: 'تعديل التقارير', hint: 'تغيير حالة الطالب أو وقت حضوره في التقرير', write: true },
                { key: 'students|alerts', title: 'اجراءات الغياب والتأخر', hint: 'خطابات وإجراءات الغياب بدون عذر والتأخر', write: true },
            ] },
            { id: 'actions', title: 'المتابعة والإجراءات', items: [
                { key: 'students|reasons', title: 'الرد على الغياب (الأعذار)', hint: 'قبول أعذار أولياء الأمور أو رفضها', write: true },
                { key: 'students|requests|leave', title: 'طلبات الاستئذان من أولياء الأمور', hint: 'الموافقة على طلب الاستئذان أو رفضه، والمناداة وتسجيل الخروج', write: true },
                { key: 'students|requests|visit', title: 'طلبات الزيارة من أولياء الأمور', hint: 'الموافقة على موعد الزيارة أو رفضه أو التواصل مع ولي الأمر', write: true },
                { key: 'students|actions', title: 'إرسال الإجراءات والأذونات للمعلمين', hint: 'إذن دخول أو خروج يصل للمعلم في تطبيقه', write: true },
                { key: 'students|bis', title: 'المخالفات السلوكية', hint: 'تسجيل المخالفات ودرجاتها', write: true },
                { key: 'students|breaks-visits', title: 'المواقف اليومية والزيارات', hint: 'المواقف الطارئة وزيارات أولياء الأمور', write: true },
                { key: 'students|certs', title: 'شهادات الشكر والتقدير', hint: 'إصدار الشهادات وإرسالها', write: true },
                { key: 'students|hours', title: 'ساعات التطوع', hint: 'تسجيل ساعات التطوع للطلاب', write: true },
            ] },
            { id: 'settings', title: 'الإعدادات', items: [
                { key: 'students|settings', title: 'ضبط الحضور والارسال', hint: 'أوقات الحضور ورسائل الغياب والإجازات', write: true },
            ] },
        ],
    },
    {
        service: 'teachers',
        icon: 'fa-user-circle-o',
        areas: [
            { id: 'view', title: 'المعلمون', items: [
                { key: 'teachers|stats', title: 'الصفحة الرئيسية والإحصائيات', hint: 'أرقام حضور المعلمين اليوم', basic: true },
                { key: 'teachers|view', title: 'استعراض المعلمين', hint: 'قائمة المعلمين وبياناتهم', basic: true },
                { key: 'teachers|add', title: 'إضافة واستيراد المعلمين', hint: 'إضافة معلم أو استيراد ملف', write: true },
                { key: 'teachers|edit', title: 'تعديل وحذف المعلمين', hint: 'الاسم والجوال والفصول المسندة والحذف', requires: ['teachers|view'], write: true },
            ] },
            { id: 'scan', title: 'التحضير', items: [
                { key: 'teachers|scan', title: 'تحضير المعلمين', hint: 'شاشة تحضير المعلمين', write: true },
                { key: 'teachers|scan|manual', title: 'تحضير يدوي', hint: 'تسجيل حضور المعلم باختياره', write: true },
                { key: 'teachers|scan|barcode', title: 'تحضير بالباركود', hint: 'قارئ الباركود', write: true },
                { key: 'teachers|scan|bulk', title: 'تحضير جماعي', hint: 'تحضير كل المعلمين مرة واحدة', write: true },
            ] },
            { id: 'reports', title: 'التقارير', items: [
                { key: 'teachers|reports|daily', title: 'الحضور والغياب والتأخر', hint: 'تقرير اليوم للمعلمين', basic: true },
                { key: 'teachers|reports|between', title: 'تقارير فترة', hint: 'حضور المعلمين بين تاريخين' },
                { key: 'teachers|fullreport', title: 'التقرير التراكمي', hint: 'مجموع الغياب والتأخر لكل معلم' },
                { key: 'teachers|reports|asks-all', title: 'مساءلات المعلمين', hint: 'المساءلات المرسلة للمعلمين' },
                { key: 'teachers|reports|edit', needsOne: ['teachers|reports|daily', 'teachers|reports|between'], title: 'تعديل التقارير', hint: 'تغيير حالة المعلم في التقرير', write: true },
            ] },
            { id: 'actions', title: 'المتابعة والإجراءات', items: [
                { key: 'teachers|mails', title: 'التعاميم', hint: 'إرسال التعاميم ومتابعة الاطلاع عليها', write: true },
                { key: 'teachers|teachers|send', title: 'ارسال رسائل للمعلمين', hint: 'رسائل واتساب أو نصية', write: true },
                { key: 'teachers|archive', title: 'ارشيف رسائل المعلمين', hint: 'الرسائل المرسلة للمعلمين' },
                { key: 'teachers|shifts', title: 'جدول المناوبة', hint: 'توزيع المناوبة', write: true },
                { key: 'teachers|shifts2', title: 'جدول الإشراف', hint: 'توزيع الإشراف اليومي', write: true },
                { key: 'teachers|certs', title: 'شهادات الشكر والتقدير', hint: 'شهادات المعلمين', write: true },
                { key: 'teachers|hudury', title: 'الربط مع حضوري', hint: 'استيراد التقارير والإجازات من حضوري', write: true },
            ] },
            { id: 'settings', title: 'الإعدادات', items: [
                { key: 'teachers|settings', title: 'اعدادات المعلمين', hint: 'أوقات الدوام والإجازات والإرسال التلقائي', write: true },
            ] },
        ],
    },
    {
        service: 'lessons',
        icon: 'fa-book',
        areas: [
            { id: 'all', title: 'غياب الحصص', items: [
                { key: 'lessons|report', title: 'تقارير الطلاب', hint: 'غياب الطلاب في الحصص' },
                { key: 'lessons|not-attended', title: 'احصائيات الفصول', hint: 'الحصص التي لم تُحضَّر' },
                { key: 'lessons|settings', title: 'الإعدادات', hint: 'إعدادات غياب الحصص', write: true },
            ] },
        ],
    },
    {
        service: 'calls',
        icon: 'fa-bullhorn',
        areas: [
            { id: 'all', title: 'المناداة', items: [
                { key: 'calls|home', title: 'شاشة المناداة', hint: 'عرض الطلاب المطلوبين عند البوابة' },
                { key: 'calls|manual', title: 'المناداة يدوياً', hint: 'استدعاء طالب من اللوحة', write: true },
                { key: 'calls|requests', title: 'طلبات التفعيل', hint: 'قبول طلبات أولياء الأمور', write: true },
                { key: 'calls|settings', title: 'اعدادات المناداة', hint: 'الصوت والشاشة والمسافة', write: true },
            ] },
        ],
    },
    {
        service: 'results',
        icon: 'fa-graduation-cap',
        areas: [
            { id: 'all', title: 'الشهادات', items: [
                { key: 'results|index', title: 'الصفحة الرئيسية', hint: 'ملخص الشهادات' },
                { key: 'results|home', title: 'ارسال الشهادات', hint: 'إرسال الشهادات لأولياء الأمور', write: true },
                { key: 'results|history', title: 'العمليات السابقة', hint: 'سجل الإرسال' },
                { key: 'results|ai', title: 'تحليل النتائج', hint: 'تحليل نتائج الطلاب' },
                { key: 'results|stats', title: 'احصائيات الشهادات', hint: 'من استلم ومن لم يستلم' },
                { key: 'results|link', title: 'الرابط الموحد للشهادات', hint: 'رابط واحد لكل أولياء الأمور', write: true },
                { key: 'results|import', title: 'استيراد الطلاب', hint: 'استيراد بيانات الطلاب للشهادات', write: true },
            ] },
        ],
    },
    {
        service: 'table',
        icon: 'fa-table',
        areas: [
            { id: 'all', title: 'الجدول المدرسي', items: [
                { key: 'table|create', title: 'إنشاء الجدول', hint: 'توليد الجدول الآن', write: true },
                { key: 'table|history', title: 'الجداول المحفوظة', hint: 'الجداول السابقة' },
                { key: 'table|teachers', title: 'ادارة المعلمين', hint: 'أنصبة المعلمين', write: true },
                { key: 'table|classrooms', title: 'ادارة الفصول', hint: 'الفصول وعدد الحصص', write: true },
                { key: 'table|subjects', title: 'ادارة المواد', hint: 'المواد والحصص الأسبوعية', write: true },
                { key: 'table|waiting', title: 'حصص الانتظار', hint: 'توزيع حصص الانتظار', write: true },
                { key: 'table|realtime', title: 'الشاشة المباشرة', hint: 'الحصص الجارية الآن' },
                { key: 'table|settings', title: 'الإعدادات العامة', hint: 'أيام الدوام وعدد الحصص', write: true },
            ] },
        ],
    },
    {
        service: 'whatsapp',
        icon: 'fa-whatsapp',
        areas: [
            { id: 'all', title: 'الواتساب', items: [
                { key: 'whatsapp|scan', also: ['home'], title: 'الصفحة الرئيسية وفحص الجهاز', hint: 'ربط رقم الواتساب وحالة الاتصال', write: true },
            ] },
        ],
    },
    // Services without inner permissions (mentors, committees, masrufi…): the switch alone opens
    // the whole service; their cards come from the school's subscriptions.
];

// Codes managed by the catalog but never shown as a row.
var HIDDEN = {
    // menu group «تقارير الطلاب»: on while any of these is on
    'students|reports': ['students|reports|daily', 'students|reports|between', 'students|reports|classrooms'],
};

// Ready-made roles. keys are filtered to the school's services when applied.
var PRESETS = [
    { id: 'all', title: 'كامل الصلاحيات', hint: 'كل شيء، بما فيه إدارة المشرفين', keys: ['*'] },
    { id: 'deputy', title: 'وكيل شؤون الطلاب', hint: 'الطلاب والتحضير والتقارير والمتابعة', keys: [
        'students', 'students|stats', 'students|students|view', 'students|students|add', 'students|students|edit',
        'students|students|move', 'students|students|send', 'students|rates', 'students|health', 'students|archive',
        'students|scan|manual', 'students|scan|barcode', 'students|scan|bulk', 'students|scan|endex', 'students|scan|end',
        'students|scan|ends', 'students|scan|phone', 'students|reports|attend-before',
        'students|reports|daily', 'students|reports|between', 'students|reports|classrooms', 'students|reports|edit', 'students|alerts',
        'students|reasons', 'students|actions', 'students|bis', 'students|breaks-visits', 'students|certs', 'students|hours',
        'students|chat', 'students|notes', 'students|weeklyplan', 'students|requests|leave', 'students|requests|visit',
        'forwards', 'archive',
        'lessons', 'lessons|report', 'lessons|not-attended',
    ] },
    { id: 'gate', title: 'مسؤول البوابة / الاستئذان', hint: 'التحضير والاستئذان والتقرير اليومي', keys: [
        'students', 'students|stats', 'students|students|view', 'students|scan|manual', 'students|scan|barcode',
        'students|scan|endex', 'students|scan|end', 'students|scan|ends', 'students|scan|phone', 'students|notes',
        'students|reports|daily', 'students|actions', 'students|requests|leave',
        'calls', 'calls|home', 'calls|manual',
    ] },
    { id: 'teachers', title: 'مشرف المعلمين', hint: 'تحضير المعلمين وتقاريرهم والتعاميم', keys: [
        'teachers', 'teachers|stats', 'teachers|view', 'teachers|scan', 'teachers|scan|manual', 'teachers|scan|barcode',
        'teachers|scan|bulk', 'teachers|reports|daily', 'teachers|reports|between', 'teachers|fullreport',
        'teachers|reports|asks-all', 'teachers|mails', 'teachers|teachers|send', 'teachers|archive',
        'teachers|shifts', 'teachers|shifts2', 'teachers|certs', 'teachers|hudury',
    ] },
    { id: 'viewer', title: 'مراقب التقارير (عرض فقط)', hint: 'يشاهد الإحصائيات والتقارير ولا يعدّل شيئاً', keys: [
        'students', 'students|stats', 'students|students|view', 'students|reports|daily', 'students|reports|between',
        'students|reports|classrooms',
        'teachers', 'teachers|stats', 'teachers|view', 'teachers|reports|daily', 'teachers|reports|between', 'teachers|fullreport',
        'lessons', 'lessons|report', 'lessons|not-attended',
    ] },
];

// ---------------------------------------------------------------- lookups

var ITEMS = {};      // key → item (with .service and .area)
CATALOG.forEach(function(group){
    group.areas.forEach(function(area){
        area.items.forEach(function(item){
            item.service = group.service;
            item.area = area.id;
            ITEMS[item.key] = item;
        });
    });
});

function groupOf(service){
    for(var i = 0; i < CATALOG.length; i++){
        if(CATALOG[i].service == service) return CATALOG[i];
    }
    return null;
}

function itemsOf(service){
    var g = groupOf(service), out = [];
    if(g) g.areas.forEach(function(a){ out = out.concat(a.items); });
    return out;
}

// Every code this catalog writes (rows, their extra codes and hidden menu codes).
function isCatalogCode(code){
    if(code == '*' || ITEMS[code] || HIDDEN[code]) return true;
    for(var k in ITEMS){
        if((ITEMS[k].also || []).indexOf(code) > -1) return true;
    }
    return false;
}

function has(pers, key){
    return pers.indexOf(key) > -1;
}

function add(pers, key){
    if(!has(pers, key)) pers.push(key);
}

function remove(pers, key){
    var i = pers.indexOf(key);
    if(i > -1) pers.splice(i, 1);
}

// ---------------------------------------------------------------- changes

// Switch one row on or off. Returns a new array plus notes on what was changed with it.
function toggle(pers, key, on){
    var out = pers.slice(), notes = [];
    var item = ITEMS[key];
    if(!item){
        if(on) add(out, key); else remove(out, key);
        return { pers: out, notes: notes };
    }
    if(on){
        switchOn(out, item, notes);
    }else{
        remove(out, key);
        (item.also || []).forEach(function(k){ remove(out, k); });
        // rows that cannot work without this one go off too
        Object.keys(ITEMS).forEach(function(k){
            var other = ITEMS[k];
            if(has(out, k) && (other.requires || []).indexOf(key) > -1){
                remove(out, k);
                notes.push('أُلغيت «' + other.title + '» لأنها تحتاج «' + item.title + '»');
            }
            if(has(out, k) && other.needsOne && other.needsOne.indexOf(key) > -1 && !other.needsOne.some(function(n){ return has(out, n); })){
                remove(out, k);
                notes.push('أُلغيت «' + other.title + '» لأنها تحتاج تقريراً واحداً على الأقل');
            }
        });
        tidyHidden(out);
    }
    return { pers: out, notes: notes };
}

function switchOn(out, item, notes){
    add(out, item.key);
    if(item.service) add(out, item.service);
    (item.also || []).forEach(function(k){ add(out, k); });
    (item.requires || []).forEach(function(k){
        if(!has(out, k)){
            if(ITEMS[k]){
                switchOn(out, ITEMS[k], notes);
                notes.push('فُعّلت «' + ITEMS[k].title + '» مع «' + item.title + '»');
            }else{
                add(out, k);
            }
        }
    });
    if(item.needsOne && !item.needsOne.some(function(k){ return has(out, k); })){
        var first = ITEMS[item.needsOne[0]];
        switchOn(out, first, notes);
        notes.push('فُعّلت «' + first.title + '» مع «' + item.title + '»');
    }
}

// hidden menu codes: on while one of their rows is on
function tidyHidden(out){
    Object.keys(HIDDEN).forEach(function(code){
        if(HIDDEN[code].some(function(k){ return has(out, k); })) add(out, code);
        else remove(out, code);
    });
}

// Switch a whole service on (with its basic rows, or all rows when it has no basic ones) or off
// (with every row inside it).
function toggleService(pers, service, on){
    var out = pers.slice(), notes = [];
    var items = itemsOf(service);
    if(on){
        add(out, service);
        var basic = items.filter(function(x){ return x.basic; });
        (basic.length ? basic : items).forEach(function(x){ switchOn(out, x, notes); });
    }else{
        remove(out, service);
        items.forEach(function(x){
            remove(out, x.key);
            (x.also || []).forEach(function(k){ remove(out, k); });
        });
        tidyHidden(out);
    }
    return { pers: out, notes: [] };
}

// All rows of one area on or off.
function toggleArea(pers, service, areaId, on){
    var g = groupOf(service), out = pers.slice(), notes = [];
    var area = g && g.areas.filter(function(a){ return a.id == areaId; })[0];
    if(!area) return { pers: out, notes: notes };
    area.items.forEach(function(x){
        var r = toggle(out, x.key, on);
        out = r.pers;
        notes = notes.concat(r.notes);
    });
    return { pers: out, notes: notes };
}

// Fills in what selected rows need (their service, required rows, extra and menu codes).
// With { dropOrphans: true } it also removes rows whose service is off. Codes the catalog does not
// know (class titles, codes added elsewhere) are always kept.
function normalize(pers, opts){
    var out = (pers || []).filter(function(x){ return x !== '' && x != null; }).map(String);
    out = out.filter(function(x, i){ return out.indexOf(x) == i; });
    var notes = [];
    if(opts && opts.dropOrphans){
        out = out.filter(function(code){
            var item = ITEMS[code];
            return !item || !item.service || has(out, item.service);
        });
    }
    out.slice().forEach(function(code){
        if(ITEMS[code] && (!ITEMS[code].service || has(out, ITEMS[code].service))) switchOn(out, ITEMS[code], notes);
    });
    tidyHidden(out);
    return out;
}

// A preset's codes for this school: only services it has, and the class selection is kept.
function applyPreset(pers, presetId, services, classTitles){
    var p = PRESETS.filter(function(x){ return x.id == presetId; })[0];
    if(!p) return pers.slice();
    var classes = pers.filter(function(x){ return (classTitles || []).indexOf(x) > -1; });
    if(p.keys.indexOf('*') > -1) return ['*'].concat(classes);
    var keys = p.keys.filter(function(k){
        var item = ITEMS[k];
        var isService = !!groupOf(k) || services.indexOf(k) > -1;
        var service = item ? item.service : (isService ? k : '');
        return !service || services.indexOf(service) > -1;
    });
    return normalize(keys).concat(classes);
}

// The preset these codes match exactly, or null («مخصص»).
function presetOf(pers, services, classTitles){
    if(has(pers || [], '*')) return PRESETS[0];
    var mine = permissionCodes(pers, classTitles).sort().join(',');
    for(var i = 0; i < PRESETS.length; i++){
        var codes = permissionCodes(applyPreset([], PRESETS[i].id, services, classTitles), classTitles).sort().join(',');
        if(codes == mine) return PRESETS[i];
    }
    return null;
}

// pers without class titles.
function permissionCodes(pers, classTitles){
    return (pers || []).filter(function(x){ return (classTitles || []).indexOf(x) < 0; });
}

// ---------------------------------------------------------------- reading

// Short chips for the supervisors list: [{ text, tone: 'all' | 'read' | 'warn' | '' }].
//   services: [{ service, title }] the school has; classTitles: the school's classnames.
function humanSummary(pers, services, classTitles){
    pers = pers || [];
    if(has(pers, '*')) return [{ text: 'كامل الصلاحيات', tone: 'all' }];
    var chips = [];
    (services || []).forEach(function(s){
        var items = itemsOf(s.service);
        var name = shortName(s);
        if(!has(pers, s.service)){
            // rows saved without the service code (old page): they do nothing until it is on
            if(items.some(function(x){ return has(pers, x.key); })) chips.push({ text: name + ': الخدمة غير مفعّلة', tone: 'warn' });
            return;
        }
        if(!items.length){
            chips.push({ text: name, tone: '' });
            return;
        }
        var mine = items.filter(function(x){ return has(pers, x.key); });
        if(mine.length == items.length){
            chips.push({ text: name + ': كاملة', tone: 'all' });
        }else if(!mine.some(function(x){ return x.write; })){
            chips.push({ text: name + ': عرض فقط', tone: 'read' });
        }else{
            chips.push({ text: name + ': ' + mine.length + ' من ' + items.length, tone: '' });
        }
    });
    var general = itemsOf('').filter(function(x){ return has(pers, x.key); });
    if(general.length) chips.push({ text: 'عامة: ' + general.length, tone: '' });
    if(!chips.length) chips.push({ text: 'بدون صلاحيات', tone: 'warn' });
    if(has(pers, 'students') && classTitles && classTitles.length){
        var n = classTitles.filter(function(c){ return has(pers, c); }).length;
        if(n == 0) chips.push({ text: 'بدون صفوف', tone: 'warn' });
        else if(n == classTitles.length) chips.push({ text: 'كل الصفوف', tone: '' });
        else chips.push({ text: n + ' من الصفوف', tone: '' });
    }
    return chips;
}

var SHORT = { students: 'الطلاب', teachers: 'المعلمين', lessons: 'الحصص', calls: 'المناداة', results: 'الشهادات',
    mentors: 'الاستبانات', committees: 'اللجان', whatsapp: 'الواتساب', table: 'الجدول', masrufi: 'مصروفي' };

function shortName(s){
    return SHORT[s.service] || s.title || s.service;
}

var ICONS = { students: 'fa-users', teachers: 'fa-user-circle-o', lessons: 'fa-book', calls: 'fa-bullhorn',
    results: 'fa-graduation-cap', mentors: 'fa-list-alt', committees: 'fa-th-large', whatsapp: 'fa-whatsapp',
    table: 'fa-table', masrufi: 'fa-money' };

function iconOf(service){
    return ICONS[service] || 'fa-cube';
}

export {
    CATALOG, PRESETS, HIDDEN, ITEMS,
    groupOf, itemsOf, isCatalogCode, permissionCodes,
    toggle, toggleService, toggleArea, normalize, applyPreset, presetOf,
    humanSummary, shortName, iconOf,
};
